import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { CommonHttpService } from "../../commonHttp.service";
import { LoaderService } from "../../../_shared/services/loader.service";
import jsSHA from "jssha";
import { toBase64String } from "@angular/compiler/src/output/source_map";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { PhonePe } from "phonepesdk-web";
import { AddToCartService } from "../../../_shared/services/add-to-cart.service";

@Component({
  selector: "app-order-detail",
  templateUrl: "./order-detail.component.html",
  styleUrls: ["./order-detail.component.css"],
})
export class OrderDetailComponent implements OnInit {
  paramsId: any;
  imageUrl: any = environment.imageUrl;
  baseUrl: any = environment.apiUrl;
  orderDetails: any = {};
  returnDetails: any = {};
  Response: any;
  ppavl: any;
  orderData: any = {}
  //PhonepeRefondTransactionId: any;
  refundTid: any;
  merchantId: any;
  userDetails: any;
  response: any;
  responseUserDetails: Object;
  isLoggedIn: any;
  param1: string;
  utm_source: string;
  newheader;
  isFromChekoutPhonePe
  constructor(
    private http: HttpClient,
    private service: CommonHttpService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private addToCartService: AddToCartService,
  ) { }

  ngOnInit() {
    // $('#asdf').click();
    this.param1 = this.route.snapshot.queryParamMap.get("utm_source");
    if (this.param1 == "phonepe") {
      console.log("ca");
      localStorage.setItem("utm_sources", JSON.stringify(this.param1));
    }
    this.isLoggedIn = localStorage.getItem("isLoggedin");
    console.log(this.isLoggedIn);
    console.log("hello");
    window.scrollTo(0, 0);
    setTimeout(() => {
      let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
      console.log(IsPhonepe);
      if (IsPhonepe == "phonepe") {
        this.ppavl = true;
        console.log(this.ppavl);
      }
    }, 1000);

    let hasPopupShown = localStorage.getItem("hasPopupShown");
    console.log(hasPopupShown);
    if (
      this.ppavl == true &&
      this.isLoggedIn == null &&
      hasPopupShown != "true"
    ) {
      console.log("direct viewsetails popup");
      this.showPopupForPhonepeLogin();
    }



    console.log(this.param1);
    this.isLoggedIn = localStorage.getItem("isLoggedin");

    if (this.isLoggedIn == null) {
      if (this.param1 == "phonepe" && this.isLoggedIn == null) {
        console.log(this.param1);
        this.showPopupForPhonepeLogin();
      } else {
        console.log("b");
        this.router.navigate(["/login"]);
      }
    } else {
      console.log("hgf");
      this.route.params.subscribe((params) => {
        this.paramsId = params["id"];
        console.log(this.paramsId);
      });
      console.log("settimeout called");
      this.loadData();
    }
  }
  // onCancelModalClick() {
  //   window.location.reload();
  // }
  // onModalClick() {
  //   window.location.href = "/checkout"

  // }
  loadData() {
    if (this.paramsId.includes('?')) {
      console.log(this.paramsId)
      this.paramsId = this.paramsId.split('?')[0]
    }
    console.log(this.paramsId)
    console.log("load data called");
    this.loaderService.display(true);
    this.http.get(this.baseUrl + "EOrderAPI/GetSingleOrder/" + this.paramsId)
      .subscribe(
        (data) => {
          this.orderData = data
          this.loaderService.display(false);

          console.log(Number(localStorage.getItem("customerId")))
          console.log(this.orderData);
          console.log(this.orderData.epaymentStatusId);
          console.log((Number(localStorage.getItem("customerId"))))
          this.checkCondition(data);

        },
        (error) => {
          this.loaderService.display(false);
        }
      );
  }
  checkCondition(data) {
    console.log(localStorage.getItem("isFromChekoutPhonePe"))
    this.isFromChekoutPhonePe = localStorage.getItem("isFromChekoutPhonePe")
    if (this.orderData.epaymentStatusId == 4) {
      console.log(this.orderData.epaymentStatusId);
      $('#asdfgh').click();
      setTimeout(() => {
        window.location.href = "/checkout"
      }, 1500);
    } else {
      if (this.orderData.eorderCustomerId != Number(localStorage.getItem("customerId"))) {
        console.log(Number(localStorage.getItem("customerId")))
        // this.router.navigate([""]);
        window.location.href = ""
      } else {
        console.log("x");
        this.orderDetails = data;
        this.orderDetails.eorderAmt = Math.round(
          this.orderDetails.eorderAmt
        );
        this.loaderService.display(false);
        console.log(this.orderDetails.epaymentStatusId)
        console.log(this.isLoggedIn)
        console.log(this.ppavl)
        console.log(this.ppavl)
        console.log(this.isFromChekoutPhonePe)

        if ((this.orderDetails.epaymentStatusId == 1 || this.orderDetails.epaymentStatusId == 2) && this.isLoggedIn == "true" && this.ppavl == true && this.isFromChekoutPhonePe == "true") {
          console.log("if called")
          localStorage.removeItem("cart");
          this.addToCartService.deleteCart();
          this.isFromChekoutPhonePe = false;
          localStorage.setItem("isFromChekoutPhonePe", null)
          console.log(localStorage.getItem("isFromChekoutPhonePe"))
        }
        this.getReturnDetails();
      }
    }
  }
  getReturnDetails() {
    this.loaderService.display(true);
    this.service
      .get(this.baseUrl + "ReturnAPI/GetReturnById/" + this.paramsId)
      .subscribe(
        (data) => {
          console.log(data);
          this.returnDetails = data[0];
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        }
      );
  }

  print(): void {
    let printContents = document.getElementById("print-section").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    location.reload();
  }

  cancelOrderPhonepe() {
    console.log("cancel method called");
    let payLoad = {
      merchantId: this.merchantId.merchantID,
      transactionId: this.refundTid,
      providerReferenceId: this.orderDetails.providerReferenceId,
      amount: this.orderDetails.egrandTotal * 100,
      merchantOrderId: this.orderDetails.eorderMasterId,
      //subMerchant": "DemoMerchant",
      message: "refund for cancelled order",
    };
    console.log(payLoad);
    let stringPayload = JSON.stringify(payLoad);
    let base64EncodedPayload = window.btoa(stringPayload);
    let base64EncodedBody = base64EncodedPayload;
    console.log(base64EncodedPayload);
    // let shaObj = new jsSHA("SHA-256", "TEXT");
    // shaObj.update(base64EncodedPayload + '/v3/credit/backToSource' + 'ee3c4a1c-a1b3-48c2-840a-b4b513b132d7');
    // let hash1 = shaObj.getHash("HEX");
    // var hash = hash1.toUpperCase()
    // // console.log(hash1)
    // console.log(hash)
    this.sendRefundDataPhonepe(base64EncodedPayload);
  }
  sendRefundDataPhonepe(base64body) {
    this.loaderService.display(true);
    let PostData = {
      request: base64body,
      XVERIFY: "test",
    };
    console.log(PostData);
    this.http
      .post(this.baseUrl + "EOrderAPI/PhonepeRefund/", PostData)
      .subscribe(
        (data) => {
          this.Response = data;
          this.loaderService.display(false);
          console.log(this.Response);
          if (this.Response.success == true) {
            this.cancelOrderNowGrocery();
          } else {
            alert("Something Wrong Happened, Order can not be cancelled");
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
  getTransactionid() {
    this.loaderService.display(true);

    this.http
      .get(this.baseUrl + "EOrderAPI/PhonepeRefondTransactionId/")
      .subscribe(
        (data) => {
          this.refundTid = data;
          console.log(this.refundTid);
          this.loaderService.display(false);
          this.getMerchantId();
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
  getMerchantId() {
    this.loaderService.display(true);

    this.http.get(this.baseUrl + "PhonepeCredentialsAPI/GetAllTrue/").subscribe(
      (data) => {
        console.log(data);
        this.merchantId = data;
        console.log(this.merchantId.merchantID);
        this.loaderService.display(false);
        this.cancelOrderPhonepe();
      },
      (error) => {
        console.log(error);
        this.loaderService.display(false);
      }
    );
  }
  cancelOrderNowGrocery() {
    this.loaderService.display(true);
    let nowGroceryObj = {
      EorderStatusId: 7,
      EPaymentStatusId: this.orderDetails.epaymentStatusId,
      EPaymentModeId: this.orderDetails.epaymentModeId,
      PhonepeRefondTransactionId: this.refundTid,
      Remarks: "Phonepe",
    };
    this.http
      .put(
        this.baseUrl +
        "EOrderAPI/UpdateEOrderStatus/" +
        this.orderDetails.eorderMasterId,
        nowGroceryObj
      )
      .subscribe(
        (data) => {
          console.log(data);
          this.loaderService.display(false);
          $('#asdf').click();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        },
        (error: any) => {
          this.loaderService.display(false);

          console.log(error);
        }
      );
  }

  showPopupForPhonepeLogin() {
    PhonePe.PhonePe.build(PhonePe.Constants.Species.web).then((sdk) => {
      sdk
        .fetchAuthToken()
        .then((res) => {
          console.log(res);
          //   alert(res.grantToken)
          // console.log(JSON.stringify(res));
          // var str = '{"grantToken":"' + res.grantToken + '"}';
          // console.log(str);
          // var encodedData = window.btoa(str);
          // console.log(encodedData);
          // this.encodedBase64 = encodedData;
          // let shaObj = new jsSHA("SHA-256", "TEXT");
          // shaObj.update(
          //   encodedData +
          //   "/v3/service/auth/access" +
          //   "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
          // );
          // let hash1 = shaObj.getHash("HEX");
          // var hash = hash1.toUpperCase();
          // console.log(hash1);
          // console.log(hash);

          this.fetchAccessToken(res.grantToken);
        })
        .catch((err) => {
          console.log(
            //{"error_code":"USER_SKIPPED","description":"User skipped"}
            "Error occurred while fetching the grant token: " + err
          );
          let error = JSON.parse(err);
          if (error.error_code == "USER_SKIPPED") {
            if (error.error_code == "USER_SKIPPED") {
              console.log("has popup shown set");
              localStorage.setItem("hasPopupShown", "true");

              //  this.router.navigate(["login"], { queryParams: { utm_source: 'phonepe' } });
            }
            this.router.navigate(["login"], {
              queryParams: {
                utm_source: "navigateToOrderDetails",
                navigateUrl: this.router.url,
              },
            });
          }
          //  alert(err);
        });
    });
  }
  fetchAccessToken(base64body) {
    //  var xVerifyHeader = hash + "###" + 1;
    //  console.log(xVerifyHeader);
    var myobj = {
      request: base64body,
      XVERIFY: "test",
    };
    console.log(myobj);
    this.loaderService.display(true);
    this.http
      .post(this.baseUrl + "LoginAPI/PhonepeLoginAsync/", myobj)
      .subscribe(
        (data) => {
          this.response = data;
          console.log(this.response);

          this.loaderService.display(false);

          //   alert(this.response)
          // console.log(this.Response.data.accessToken);
          // let shaObj = new jsSHA("SHA-256", "TEXT");
          // shaObj.update(
          //   "/v3/service/userdetails" + "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
          // );
          // let hash1 = shaObj.getHash("HEX");
          // var hash = hash1.toUpperCase();
          // console.log(hash1);
          // console.log(hash);
          // var xVerifyHeader = hash + "###" + 1;
          this.getUserDetails(this.response.data.accessToken);
        },
        (error: any) => {
          console.log(error);
          this.loaderService.display(false);
        }
      );
  }
  getUserDetails(accessToken) {
    var userDetailobj = {
      request: accessToken,
      XVERIFY: "test",
    };
    this.loaderService.display(true);

    this.http
      .post(this.baseUrl + "LoginAPI/GetUserDetails/", userDetailobj)
      .subscribe(
        (data) => {
          console.log(data);
          this.responseUserDetails = data;
          this.loaderService.display(false);
          //data.name,data.phoneNumber
          console.log(this.responseUserDetails);
          this.postUserDetails(this.responseUserDetails);
        },
        (error: any) => {
          console.log(error);
          this.loaderService.display(false);
        }
      );
  }
  postUserDetails(userdetails) {
    var postData = {
      MobileNumber: userdetails.data.phoneNumber,
      Name: userdetails.data.name,
      LoginType: "Phonepe",
      Email: userdetails.data.email != undefined ? userdetails.data.email : "",
    };
    console.log(postData);
    this.loaderService.display(true);

    this.http
      .post(this.baseUrl + "LoginAPI/PhonepeSilentLogin/", postData)
      .subscribe(
        (data) => {
          this.userDetails = data;
          this.loaderService.display(false);

          if (this.userDetails.statusCode == 1) {
            localStorage.setItem("customerId", this.userDetails.customerId);
            localStorage.setItem("customerName", this.userDetails.customerName);
            localStorage.setItem("customerMobile", this.userDetails.mobileNumber);
            localStorage.setItem("isLoggedin", "true");
            console.log("login in now grocery via phone pe completed");
            this.route.params.subscribe((params) => {
              this.paramsId = params["id"];
            });
            console.log(this.paramsId);
            this.loadData();
            // this.getReturnDetails();
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/orders/order-detail/order-detail.component.ts